import { SYSTEM_NAME_ARRAY } from './../constants';

export function getRecommendation(capacity) {
    if (capacity === 0) {
        return '-'
    }
    if (capacity <= 27) {
        return SYSTEM_NAME_ARRAY[0];
    }
    if (capacity <= 54) {
        return SYSTEM_NAME_ARRAY[1];
    }
    if (capacity <= 81) {
        return SYSTEM_NAME_ARRAY[2];
    }
    if (capacity <= 135) {
        return SYSTEM_NAME_ARRAY[3];
    }
    if (capacity <= 202.5) {
        return SYSTEM_NAME_ARRAY[4];
    }
    if (capacity <= 270) {
        return SYSTEM_NAME_ARRAY[5];
    } else {
        return "Für Großanlagen Kontaktieren Sie bitte unseren Support";
        // override all results?
    }
}